<template>
  <div class="forget">
    <h2>修改密码</h2>
    <div class="step">
      <el-steps :active="active" finish-status="success">
        <el-step title="验证手机号"></el-step>
        <el-step title="修改密码"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
    </div>

    <div class="step1" v-if="active === 0">
      <div class="mobile">
        <input
          type="text"
          placeholder="请输入手机号码"
          v-model.number="mobile"
        />
      </div>

      <div class="code inpFlex">
        <input
          type="text"
          placeholder="请输入验证码"
          class="codeInp"
          v-model.number="code"
        />
        <button class="codeBtn" @click="getCode">
          {{
            this.currentSecond === this.second
              ? "获取验证码"
              : this.currentSecond + "s后重新获取"
          }}
        </button>
      </div>

      <div>
        <button class="nextBtn1" @click="nextBtn1">下一步</button>
      </div>
    </div>
    <div class="step2" v-if="active === 1">
      <div class="pwd">
        <input
          type="password"
          placeholder="请输入新密码"
          v-model.number="pwd"
        />
      </div>

      <div class="pwdAgain">
        <input
          type="password"
          placeholder="请确认新密码"
          v-model.number="pwdAgain"
          @blur="checkPwd"
        />
      </div>

      <div>
        <button class="nextBtn1" @click="nextBtn2">确认</button>
      </div>
    </div>
    <div class="step3" v-if="active === 3">
      <p>
        密码修改成功，<span class="nowLogin" @click="$router.replace('/login')">
          {{ nowLoginCountDown }}s去登录
          <i class="el-icon-right"></i>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import { sendForgetCode, checkForgetCode, forgetPwdUpdate } from '@/api/common'
export default {
  name: 'ForgetIndex',
  data () {
    return {
      mobile: '',
      code: '',
      pwd: '',
      pwdAgain: '',
      currentSecond: 60,
      second: 60,
      timerId: null,
      active: 0,
      nowLoginCountDown: 10
    }
  },
  methods: {
    checkPwd () {
      if (this.pwd !== this.pwdAgain) {
        this.$toast.fail('两次输入的密码不一致，请重新输入')
      }
    },
    async getCode () {
      if (!this.mobile) {
        this.$toast.fail('请输入手机号码')
        return
      }
      const reg = /^1[3-9]\d{9}$/
      if (!reg.test(this.mobile)) {
        this.$toast.fail('手机号格式错误')
        return
      }

      // 可以发送验证码
      if (!this.timerId && this.currentSecond === this.second) {
        await sendForgetCode(this.mobile)
        this.currentSecond--
        this.timerId = setInterval(() => {
          this.currentSecond--
          if (this.currentSecond <= 0) {
            this.currentSecond = this.second
            clearInterval(this.timerId)
            this.timerId = null
          }
        }, 1000)
        this.$toast.success('验证码发送成功')
      }
    },
    async nextBtn1 () {
      if (!this.mobile || !this.code) {
        this.$toast.fail('请填写完整数据')
        return
      }

      // 校验验证码
      const result = await checkForgetCode(this.mobile, this.code)
      this.$toast.success(result.data)

      this.active++
    },
    async nextBtn2 () {
      if (!this.pwd || !this.pwdAgain || !this.mobile || !this.code) {
        this.$toast.fail('请填写完整数据')
        return
      }
      if (this.pwd !== this.pwdAgain) {
        this.$toast.fail('两次输入的密码不一致，请重新输入')
        return
      }

      // 调用修改密码接口
      const result = await forgetPwdUpdate(
        this.mobile,
        this.code,
        this.pwd,
        this.pwdAgain
      )

      this.active += 2
      // 去登录倒计时
      this.timerId2 = setInterval(() => {
        this.nowLoginCountDown--
        if (this.nowLoginCountDown <= 0) {
          this.nowLoginCountDown = 10
          clearInterval(this.timerId2)
          this.$router.replace('/login')
        }
      }, 1000)

      this.$toast.success(result.data)
    }
  }
}
</script>

<style lang="less" scoped>
.forget {
  width: 600px;
  height: 100%;
  background-color: #fff;
  padding: 40px;
  margin: 0 auto;
  .step {
    margin: 30px 0;
  }
  .step3 {
    text-align: center;
    .nowLogin {
      cursor: pointer;
      color: #39f;
    }
  }
  .inpFlex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .codeBtn {
    color: #fff;
    background-color: #2d8cf0;
    border-color: #2d8cf0;
    padding: 4px 0;
    width: 130px;
    border-radius: 4px;
    font-size: 14px;
    margin-left: 30px;
  }
  .pwd,
  .pwdAgain,
  .mobile,
  .code {
    margin: 20px 0;
    input {
      width: 100%;
      height: 32px;
      padding: 4px 7px;
      font-size: 14px;
      border: 1px solid #dcdee2;
      border-radius: 4px;
      color: #515a6e;
      background-color: #fff;
      background-image: none;
      cursor: text;
    }
  }
  .nextBtn1 {
    color: #fff;
    background-color: #2d8cf0;
    border-color: #2d8cf0;
    height: 40px;
    width: 100%;
    border-radius: 4px;
  }
}
</style>
